import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";

const ProductTemplate = ({
  title,
  subtitle,
  description,
  specifications,
  renders,
  typologies,
  sections,
  relatedFiles,
}) => {
  return (
    <div>
      {/* Header Section */}
      <div className="flex flex-col justify-center pt-12 pb-12 md:pt-32 bg-white">
        <div className="md:container relative flex flex-col md:flex-row md:space-x-5 space-y-3 md:space-y-0 p-0 max-w-sm md:max-w-full mx-auto">
          <div className="w-full md:w-2/4 pt-2 md:p-6 flex flex-col space-y-2 md:pb-10">
            <h3 className="text-4xl md:text-6xl md:text-center leading-8 font-suranna font-medium tracking-wider md:p-6">
              {title}
            </h3>
            <h3 className="font-montserrat font-normal text-black md:text-center text-lg pb-3 text-md md:text-lg tracking-wide">
              {subtitle}
            </h3>
            <div className="md:hidden max-w-xl pb-6">
              <img
                src={renders[0]}
                alt={`${title} Cover`}
                className="object-cover w-full h-full"
              />
            </div>
            <div className="md:p-12 md:pr-32 md:pl-32">
              <p className="text-left leading-8 font-montserrat font-medium md:text-base tracking-narrow pb-5">
                {description}
              </p>
              <p className="text-left leading-8 font-montserrat font-semibold text-xl tracking-narrow md:pb-2">
                Specifications
              </p>
              <div className="md:block md:pb-12">
                <div className="grid md:grid-cols-3 max-w-7xl md:text-base text-left pt-6">
                  {specifications.map((spec, index) => (
                    <span key={index} className="pr-10 font-semibold">
                      {spec.label}
                      <span className="pr-10 block font-normal pb-4">
                        {spec.value}
                      </span>
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="hidden md:block md:w-2/4 pr-32 h-full">
            <img
              src={renders[0]}
              alt={`${title} Cover`}
              className="object-cover w-full h-full"
            />
          </div>
        </div>
      </div>

{/* Render Section */}
<div className="flex flex-col justify-center pb-12 bg-white">
  <div className="md:block w-full md:w-4/4 pt-2 flex flex-col space-y-2 mx-auto md:pb-12">
    <div className="md:container md:grid md:grid-cols-2 gap-2 mx-auto">
      {renders.slice(1).map((render, index) => ( // Start from the second render
        <div key={index} className="w-full pb-4 md:pb-0">
          <img src={render} alt={`${title} Render ${index + 2}`} />
        </div>
      ))}
    </div>
  </div>
</div>

    {/* Typologies Section */}
{typologies && typologies.length > 0 && (
  <div className="md:container relative flex flex-col md:flex-row md:space-x-5 space-y-3 md:space-y-0 p-0 max-w-sm md:max-w-full mx-auto">
    <div className="w-full md:w-4/4 md:pt-2 md:p-6 flex flex-col space-y-2 md:pb-10">
      <h3 className="md:pl-32 font-montserrat font-semibold text-left tracking-widest text-black text-base underline leading-6 underline-offset-8">
        TYPOLOGIES
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-6 md:pl-32 max-w-7xl text-sm md:text-base font-montserrat text-left pt-6">
        {typologies.map((typology, index) => (
          <span key={index} className="pr-10 pb-4">
            <img
              src={typology.image}
              alt={`${title} Typology ${index + 1}`}
              className="object-contain h-24 mt-auto mx-auto"
            />
            {typology.caption}
          </span>
        ))}
      </div>
    </div>
  </div>
)}

      {/* Sections */}
{sections && sections.length > 0 && (
  <div className="flex flex-col justify-left pb-2">
    <h3 className="md:pl-32 pl-2 pb-6 md:pb-12 md:pt-12 font-montserrat font-semibold text-left tracking-widest text-black text-base underline leading-6 underline-offset-8">
      SECTIONS
    </h3>
    <div className="md:pl-32 md:pr-32 relative flex flex-col md:flex-row md:space-x-5 space-y-3 md:space-y-0 md:pb-6 bg-white">
      {sections.map((section, index) => (
        <div key={index} className="md:w-full md:2/2 grid place-items-center">
          <img
            src={section}
            alt={`${title} Section ${index + 1}`}
            className="object-cover w-full h-full"
          />
        </div>
      ))}
    </div>
  </div>
)}
 {/* Related Files */}
 <h3 className="md:pl-32 md:pt-12 pl-2 font-montserrat font-semibold text-left tracking-widest text-black text-base underline leading-6 underline-offset-8">
        RELATED FILES
      </h3>
      <div className="flex flex-col p-3 md:pl-32 md:pt-12 items-start">
        {relatedFiles.map((file, index) => (
          <div key={index} className="mb-6"> {/* Increased spacing with mb-6 */}
            <a href={file.link} className="font-bold">
              <FontAwesomeIcon
                className="pr-4 fa-3x" // Adjusted spacing between icon and text
                icon={faFilePdf}
                style={{ color: "#E5B50B" }}
              />{" "}
              {file.label}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};


export default ProductTemplate;